module.exports = "/_next/static/images/Janel-52e457d336c81762237345a9c3ade9eb.jpg";